module.exports = __webpack_public_path__ + "img/graphic-1.22b046f6.png";